'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Configuration', 'AVRO.Common.Moment'];
module.exports = angular.module('AVRO.Common.BidPrice', dependencies).controller('BidPriceController', require('./controllers/BidPriceController')).directive('rmBidPrice', require('./directives/BidPriceDirective'));